import React from 'react'
import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts'


function LSMChart({data}) {
  return (
    <div className='text-black'>
<h3 className="text-lg font-semibold mb-4">Language Style Matching Scores</h3>
    <ResponsiveContainer width="100%" height={300} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="timestamp" />
        <YAxis />
        <Tooltip  />
        <Legend />
        <Line type="monotone" dataKey="score" stroke="#8884d8" name="LSM Score" />
      </LineChart>
    </ResponsiveContainer>
    </div>
  )
}

export default LSMChart
